import type { ActiveOrdersNanodropData } from './types'
import { QueryOptions } from '@/resources/types'
import { gql } from 'graphql-request'
import { useQuery, QueryClient } from '@/proxy/react-query'
import { client } from '@/proxy/client'

export const ACTIVE_ORDERS_NANODROP = gql`
  query sellerActiveNanodrop {
    activeOrdersNanodrop {
      orderNumber
      sourceOrderNumber
      orderStatus
      receivedAt
      statusUpdateAt
      scheduledDeliveryAt
      methodOfPayment
      totalAmount
      client {
        name
        document
        latitude
        longitude
      }
      products {
        id
        name
        quantity
        price
      }
      statusHistory {
        date
        status
        reason
        courierName
        author
      }
    }
  }
`

export const ACTIVE_ORDERS_NANODROP_QUERY_KEY = 'useActiveOrdersNanodrop'

export const activeOrdersNanodropFullListQueryKey = [
  ACTIVE_ORDERS_NANODROP_QUERY_KEY,
]

export const useActiveOrdersNanodrop = (options: QueryOptions = {}) =>
  useQuery<ActiveOrdersNanodropData>({
    queryKey: [ACTIVE_ORDERS_NANODROP_QUERY_KEY],
    queryFn: ({ signal }) =>
      client.request<ActiveOrdersNanodropData>({
        document: ACTIVE_ORDERS_NANODROP,
        signal,
      }),
    ...options,
  })

export const invalidateActiveOrdersNanodropQuery = async ({
  queryClient,
}: {
  queryClient: QueryClient
}) => {
  await queryClient.invalidateQueries({
    queryKey: [ACTIVE_ORDERS_NANODROP_QUERY_KEY],
  })
}
